import request from "@/utils/request";

// 微电网收益排名
export const parkRank = (params) => {
  return request({
    url: "/api/hzn-home/gridVisual/parkRank",
    method: "get",
    params,
  });
};

// 容量与电量
export const chargingAndDischarging = (params) => {
  return request({
    url: "/api/hzn-home/gridVisual/chargingAndDischarging",
    method: "get",
    params,
  });
};

// 园区列表
export const parkList = (params) => {
  return request({
    url: "/api/hzn-home/gridVisual/parkList",
    method: "get",
    params,
  });
};

// 光储充数据年统计
export const yearTotal = (params) => {
  return request({
    url: "/api/hzn-home/gridVisual/yearTotal",
    method: "get",
    params,
  });
};

// 上月电量与收益统计
export const eleAndIncome = (params) => {
  return request({
    url: "/api/hzn-home/gridVisual/eleAndIncome",
    method: "get",
    params,
  });
};

// 当月电量与收益统计
export const eleAndIncomeByDate = (params) => {
  return request({
    url: "/api/hzn-home/gridVisual/eleAndIncomeByDate",
    method: "get",
    params,
  });
};

// 总收益碳排放量节约汽油...统计
export const carbonTotal = (params) => {
  return request({
    url: "/api/hzn-home/gridVisual/carbonTotal",
    method: "get",
    params,
  });
};

// 削峰填谷提示
export const peakTip = (params) => {
  return request({
    url: "/api/hzn-home/gridVisual/peakTip",
    method: "get",
    params,
  });
};

// 近30日光伏发电量
export const gen30DayData = (params) => {
  return request({
    url: "/api/hzn-home/gridVisual/gen30DayData",
    method: "get",
    params,
  });
};

// 储能近30日充放
export const storage30DayData = (params) => {
  return request({
    url: "/api/hzn-home/gridVisual/storage30DayData",
    method: "get",
    params,
  });
};

// 负荷近30日用电
export const load30DayData = (params) => {
  return request({
    url: "/api/hzn-home/gridVisual/load30DayData",
    method: "get",
    params,
  });
};

// 今日运行功率曲线
export const todayGenAndStoPower = (params) => {
  return request({
    url: "/api/hzn-home/gridVisual/TodayGenAndStoPower",
    method: "get",
    params,
  });
};

// 近39日收益统计
export const dayGenAndStoEarn = (params) => {
  return request({
    url: "/api/hzn-home/gridVisual/30dayGenAndStoEarn",
    method: "get",
    params,
  });
};
